/**
 * Words for the «رسالة الاطمئنان» strip in the inbox (tasks/stay-check-message.md D14).
 *
 * The strip appears only when the automatic stay-check message was NOT sent because the guest had
 * already written to us after entering the apartment. It is for the team, never the guest.
 *
 * The note is worded so it does not push a "closing" line onto an issue that is still open — it
 * leaves that judgement with the team (consultant round 2). The ready line is inserted into the
 * reply box for the team to edit and send by hand; nothing is ever sent from here.
 *
 * Arabic only, per the Arabic-first mandate. Same pattern as `arrivalLabels.js`.
 */
export const STAY_CHECK_PROMPT = {
  note: 'تواصل الضيف معنا بعد دخوله — إذا تمّ حل طلبه، يُفضّل التأكد أن كل شيء الآن على ما يرام.',
  // Names what lands in the reply box, so ops know before clicking (founder, 2026-10-04).
  insert: 'أضف رسالة الاطمئنان',
  dismiss: 'إخفاء',
  // Reads right whenever it is used — minutes or hours after the guest's request (founder, 2026-10-04).
  readyLine: 'ضيفنا العزيز، حبينا نطمّن، إن شاء الله كل شي تمام؟ وإذا احتجت أي شيء ثاني كلمنا وأبشر 🌿'
};
